import { Reveal, Eyebrow } from "./Motion";
import { Sparkles } from "lucide-react";

export const Facilitator = ({ config }) => {
  const bio = (config?.facilitator_bio || "").split(/\n\s*\n/).filter(Boolean);
  return (
    <section id="facilitator" className="bg-[#F0EDF7] py-20 lg:py-32" data-testid="facilitator-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-start gap-16 px-6 sm:px-8 lg:grid-cols-[0.75fr_1.25fr] lg:px-12">
        <Reveal className="lg:sticky lg:top-32">
          <div className="relative mx-auto max-w-xs">
            <div className="absolute -inset-4 rotate-3 rounded-full bg-[#E8E3F0]" />
            <div className="absolute -inset-4 -rotate-2 rounded-full border border-[#D9C3A3]/70" />
            <img
              src="/facilitator.png"
              alt={`Portrait of ${config?.facilitator_name || "the facilitator"}`}
              className="relative aspect-square w-full rounded-full border-4 border-white object-cover shadow-xl shadow-[#262320]/15"
              data-testid="facilitator-portrait"
            />
          </div>
        </Reveal>
        <div>
          <Reveal>
            <Eyebrow>Your facilitator</Eyebrow>
            <h2 className="mt-5 font-serif text-3xl font-light tracking-tight text-[#262320] sm:text-4xl lg:text-5xl">
              Meet {config?.facilitator_name || "Shreya Sarkar"}
            </h2>
            {config?.facilitator_role && (
              <p className="mt-4 font-serif text-lg italic text-[#5E7D6A] sm:text-xl" data-testid="facilitator-role">
                {config.facilitator_role}
              </p>
            )}
          </Reveal>
          <Reveal delay={0.12}>
            <div className="mt-7 max-w-2xl space-y-5 text-base leading-relaxed text-[#6E6862]" data-testid="facilitator-bio">
              {bio.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2} className="mt-8 flex flex-wrap gap-3">
            {["Clinical Hypnotherapy", "Expressive Art Therapy", "Breathwork", "Sound Healing", "Mindfulness", "Somatic Practices"].map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-2 rounded-full border border-[#5E7D6A]/30 bg-white/70 px-4 py-2 text-xs text-[#5E7D6A]"
              >
                <Sparkles size={12} />
                {tag}
              </span>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
